<template>
  <!-- ========== STIMMEN: Redewechsel ========== -->
  <section class="k-sec reveal" id="stimmen">
    <div class="k-head">
      <span class="k-eyebrow">Stimmen aus der Community</span>
      <h2>Warum Mitglieder <span class="grad">wiederkommen</span>.</h2>
      <p>Keine großen Versprechen — nur das, was Mitglieder über ihre Gespräche erzählen.</p>
    </div>
    <div class="ks" data-ks>
      <figure class="ks-voice">
        <svg class="ks-mark" viewBox="0 0 88 64" aria-hidden="true">
          <use href="#ks-quote" />
        </svg>
        <blockquote>Ich hätte nicht gedacht, dass mir Schreiben so viel Spaß macht. Man merkt sofort, <em class="ks-hl">ob es passt</em>.</blockquote>
        <figcaption class="ks-who">
          <span class="ks-ava"><img :src="img('thomas')" alt="" loading="lazy" decoding="async" width="51" height="51"></span>
          <span class="ks-id"><span class="ks-nm">Thomas, 48</span><span class="ks-stars" role="img" aria-label="5 von 5 Sternen"><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg></span></span>
          <span class="ks-ctx">über seine ersten Wochen</span>
        </figcaption>
      </figure>
      <figure class="ks-voice">
        <svg class="ks-mark" viewBox="0 0 88 64" aria-hidden="true">
          <use href="#ks-quote" />
        </svg>
        <blockquote>Endlich Gespräche, die nicht nach zwei Nachrichten einschlafen — sondern <em class="ks-hl">erst richtig anfangen</em>.</blockquote>
        <figcaption class="ks-who">
          <span class="ks-ava"><img :src="img('mia')" alt="" loading="lazy" decoding="async" width="51" height="51"></span>
          <span class="ks-id"><span class="ks-nm">Mia, 25</span><span class="ks-stars" role="img" aria-label="5 von 5 Sternen"><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg></span></span>
          <span class="ks-ctx">über Gespräche mit Substanz</span>
        </figcaption>
      </figure>
      <figure class="ks-voice">
        <svg class="ks-mark" viewBox="0 0 88 64" aria-hidden="true">
          <use href="#ks-quote" />
        </svg>
        <blockquote>Abends kurz reinschauen und ein gutes Gespräch führen — <em class="ks-hl">genau mein Tempo</em>.</blockquote>
        <figcaption class="ks-who">
          <span class="ks-ava"><img :src="img('stephan')" alt="" loading="lazy" decoding="async" width="51" height="51"></span>
          <span class="ks-id"><span class="ks-nm">Stephan, 35</span><span class="ks-stars" role="img" aria-label="5 von 5 Sternen"><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg></span></span>
          <span class="ks-ctx">über sein Feierabend-Ritual</span>
        </figcaption>
      </figure>
      <figure class="ks-voice">
        <svg class="ks-mark" viewBox="0 0 88 64" aria-hidden="true">
          <use href="#ks-quote" />
        </svg>
        <blockquote>Ich dachte erst, das ist nichts für mich. Inzwischen freue ich mich <em class="ks-hl">auf jede Antwort</em>.</blockquote>
        <figcaption class="ks-who">
          <span class="ks-ava"><img :src="img('anna')" alt="" loading="lazy" decoding="async" width="51" height="51"></span>
          <span class="ks-id"><span class="ks-nm">Anna, 54</span><span class="ks-stars" role="img" aria-label="5 von 5 Sternen"><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg><svg viewBox="0 0 24 24" fill="#C63E7C"><use href="#star" /></svg></span></span>
          <span class="ks-ctx">über ihren Anfang</span>
        </figcaption>
      </figure>
    </div>
  </section>
</template>

<script>
import { profileImg } from './profiles';

export default {
  name: 'KennenlernenStimmenSection',
  methods: {
    img: profileImg,
  },
};
</script>
